import axios from "../AxiosClient";

export function getClientId(type, returnFunction) {
  let requestType = "";
  if (type === "GOOGLE_DRIVE") {
    requestType = "GOOGLE_CLIENT_ID";
  } else if (type === "SHAREPOINT" || type === "ONEDRIVE") {
    requestType = "MICROSOFT_CLIENT_ID";
  } else if (type === "SALESFORCE") {
    requestType = "SALESFORCE_CLIENT_ID";
  } else if (type === "DROPBOX") {
    requestType = "DROPBOX_BUSINESS_CLIENT_ID";
  } else if (type === "DROPBOX") {
    requestType = "DROPBOX_USER_CLIENT_ID";
  }
  if (requestType != "") {
    axios.get(`/oauthdetails/${requestType}/`, {}).then((res) => {
      returnFunction({ res, type });
    });
  }
}
